import React from 'react';
import ReactQuill from 'react-quill';
import {
  Delta,
  Sources,
  StringMap,
  RangeStatic,
  DeltaStatic,
  BoundsStatic,
} from 'quill';
import { EDITOR_FORMATS, EDITOR_MODULES } from 'utils/editorUtils';

export interface UnprivilegedEditor {
  getLength(): number;
  getText(index?: number, length?: number): string;
  getHTML(): string;
  getBounds(index: number, length?: number): BoundsStatic;
  getSelection(focus?: boolean): RangeStatic;
  getContents(index?: number, length?: number): DeltaStatic;
}

// React Quill props are not exported from react-quill/types.d.ts file
export type ReactQuillProps = {
  id?: string;
  className?: string;
  theme?: string;
  style?: React.CSSProperties;
  readOnly?: boolean;
  value?: string | Delta;
  defaultValue?: string | Delta;
  placeholder?: string;
  tabIndex?: number;
  bounds?: string | HTMLElement;
  scrollingContainer?: string | HTMLElement;
  onChange?: (
    content: string,
    delta: Delta,
    source: Sources,
    editor: UnprivilegedEditor,
  ) => void;
  onChangeSelection?: (
    range: RangeStatic,
    source: Sources,
    editor: UnprivilegedEditor,
  ) => void;
  onFocus?: (
    range: RangeStatic,
    source: Sources,
    editor: UnprivilegedEditor,
  ) => void;
  onBlur?: (
    previousRange: RangeStatic,
    source: Sources,
    editor: UnprivilegedEditor,
  ) => void;
  onKeyPress?: React.EventHandler<any>;
  onKeyDown?: React.EventHandler<any>;
  onKeyUp?: React.EventHandler<any>;
  formats?: string[];
  children?: React.ReactElement<any>;
  modules?: StringMap;
  preserveWhitespace?: boolean;
  toolbar?: never;
};

export default function BaseTextEditor(props: ReactQuillProps) {
  const { modules = EDITOR_MODULES, formats = EDITOR_FORMATS, ...rest } = props;

  return <ReactQuill {...rest} formats={formats} modules={modules} />;
}
